module.exports = __webpack_public_path__ + "img/1.70bb409a.png";